module.exports = __webpack_public_path__ + "static/media/sharebg.4046fe02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sharebg.png
// module id = 639
// module chunks = 0